import "@fortawesome/fontawesome-free/css/all.css"
import Vue from "vue"
import Vuetify from "vuetify/lib"
import getEnv from "../utils/env"

Vue.use(Vuetify)

let envColor = "#1e7c83"
switch (getEnv("VUE_APP_ENVIRONMENT_BANNER")) {
case "development":
	envColor = "#cf2046"
	break
case "staging":
	envColor = "#464d74"
	break
default:
	break
}

export default new Vuetify({
	icons: {
		iconfont: "fa",
	},
	theme: {
		options: {
			customProperties: true,
		},
		themes: {

			light: {
				primary: "#1E7C83",
				secondary: "#3d2645",
				accent: "#4ca0a7",
				audit: "#227e85",
				trace: "#7062a6",
				chain: "#325593",
				connections: "#e9aa64",
				supplierPerformance: "#217b7f",
				sustainability: "#1e9a74",
				nis: "#5b6b8c",
				env: envColor || "#1e7c83",
				orangeButton: "#DE8F18",
				darkColor: "#171717"
			}
		}
	}
})
